import { v4 as uuidv4 } from 'uuid';
import { logElevateCustomerKey } from './elevateCustomerKeyLog';

const updateVoyadoDiscoveryKey = async (customer, clientCustomerKey) => {
  if (!customer) return null;

  // Engage has no discoveryKey yet — use the Elevate session key (Voyado docs: new visitor / sign-up flow)
  const newKey = clientCustomerKey || uuidv4();
  logElevateCustomerKey('patch Engage discoveryKey', {
    contactId: customer?.id,
    discoveryKey: newKey,
    fromClientSession: Boolean(clientCustomerKey)
  });
  await fetch(
    `/api/voyadoproxy?path=/api/v3/contacts/${customer?.id}`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        discoveryKey: newKey
      })
    }
  );
  return newKey;
};

export const getDiscoveryKeyFromContact = async (
  contact,
  clientCustomerKey
) => {
  if (!contact) return null;

  let discoveryKey = contact.discoveryKey ?? contact.attributes?.discoveryKey;

  if (!discoveryKey) {
    logElevateCustomerKey('no Engage discoveryKey on contact', {
      contactId: contact?.id,
      clientCustomerKey: clientCustomerKey ?? null
    });
    discoveryKey = await updateVoyadoDiscoveryKey(contact, clientCustomerKey);
  } else {
    logElevateCustomerKey('found Engage discoveryKey', {
      contactId: contact?.id,
      discoveryKey:
        typeof discoveryKey === 'object' ? discoveryKey.value : discoveryKey
    });
  }
  if (typeof discoveryKey === 'string') return discoveryKey;
  if (typeof discoveryKey === 'object' && discoveryKey.value != null) {
    return String(discoveryKey.value);
  }

  return null;
};

export const fetchVoyadoDiscoveryKey = async (externalId, clientCustomerKey) => {
  if (!externalId) return null;

  const path = `/api/v3/contacts/${encodeURIComponent(String(externalId))}`;
  const response = await fetch(
    `/api/voyadoproxy?path=${encodeURIComponent(path)}`
  );

  if (!response.ok) {
    logElevateCustomerKey('fetch contact failed', {
      externalId,
      status: response.status
    });
    return null;
  }

  const contact = await response.json();

  return await getDiscoveryKeyFromContact(contact, clientCustomerKey);
};
